@if (component_constants?.length > 0) {
  <ul style="list-style: none;padding-left: 0;display:flex;flex-wrap:wrap;">
    @for (component_constant of component_constants; track component_constant) {
      <li class="flex-item" style="margin-right:10px;">
        <table>
          <thead>
            <tr>
              <th style="max-width:200px;white-space: nowrap; text-overflow: ellipsis; overflow: hidden; width:200px;">
                @if (constant_property_dict[component_constant.relationships.constant_property.data.id]?.attributes.name) {
                  <label title="id: {{ component_constant.id }}"
                    >
                    {{ constant_property_dict[component_constant.relationships.constant_property.data.id]?.attributes.name}}
                  : </label>
                }
                @if (constant_property_dict && !constant_property_dict[component_constant.relationships.constant_property.data.id]) {
                  <label style="color:red;font-weight: bold;"
                    matTooltip="This constant has a value saved for a property that no longer belongs to the selected component type."
                    >
                    {{component_constant.attributes.name}} not on selected type!
                  </label>
                }
              </th>
              @if (component_constant.hasOwnProperty('id') && flowchart) {
                <th>Show</th>
              }
              @if (component_constant.hasOwnProperty('id') && !flowchart) {
                <th></th>
                }<!--delete-->
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="width:180px;max-width:250px;border:1px solid #999999 !important;">
                  <constant-field [constant_value]="component_constant.attributes.value"
                    [constant_property]="constant_property_dict[component_constant.relationships.constant_property.data.id]"
                    (constant_changed)="component_constant.attributes.value = $event;"
                    (change_complete)="addConstantComponent(component_constant)"
                    [disabled]="constant_property_dict[component_constant.relationships.constant_property.data.id]?.attributes.is_calculation"
                    class="constant-field"
                  ></constant-field>
                </td>
                @if (component_constant.hasOwnProperty('id') && flowchart) {
                  <td style="vertical-align: middle;">
                    @if (component_constant.hasOwnProperty('id') && tree_position == 'parent') {
                      <mat-checkbox
                        style="width:20px;margin:0;min-width:unset;"
                        [(ngModel)]="component_constant.attributes.view_on_parent_flowchart"
                        (change)="addConstantComponent(component_constant)"
                      aria-label="Show on flowchart"></mat-checkbox>
                    }
                    @if (component_constant.hasOwnProperty('id') && tree_position == 'child') {
                      <mat-checkbox
                        style="width:20px;margin:0;min-width:unset;"
                        [(ngModel)]="component_constant.attributes.view_on_flowchart"
                        (change)="addConstantComponent(component_constant)"
                      aria-label="Show on flowchart"></mat-checkbox>
                    }
                  </td>
                }
                <td style="width:20px;min-width:20px;">
                  @if (component_constant.id) {
                    <i (click)="deleteConstantComponent(component_constant)"
                      class="fa fa-trash hideonprint" style="font-size:18px;cursor:pointer;margin-top:2px;">
                    </i>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </li>
      }
    </ul>
  }
  @if (component_constants?.length < 1) {
    <div>No component constants to display.</div>
  }
